import { ApiClient } from "./ApiClient";

export class ApiContext {
  constructor(protected client: ApiClient) {}
}
